import { useAuthStore } from '@/modules/auth/stores/auth.store'

const DASHBOARD_INSIGHTS_MODULE = 'dashboard-insights'
const LEGACY_HOME_ROUTE = 'HomeKpiDashboard'

async function ensureHomeAccessContext(authStore) {
  const hasContext = Boolean(authStore.userData && authStore.tenantData && authStore.companyData)
  if (!hasContext) {
    await authStore.fetchUserData()
  }
}

async function isNewHomeEnabled() {
  const authStore = useAuthStore()
  await ensureHomeAccessContext(authStore)

  return authStore.tenantData?.enabledModules?.includes(DASHBOARD_INSIGHTS_MODULE) ?? false
}

async function validateNewHomeAccess() {
  if (await isNewHomeEnabled()) {
    return true
  }

  return { name: LEGACY_HOME_ROUTE }
}

async function validateLegacyHomeAccess() {
  if (await isNewHomeEnabled()) {
    return { name: 'Home' }
  }

  return true
}

const index = [
  {
    path: '/',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'home',
    },
    children: [
      {
        path: '',
        name: 'Home',
        beforeEnter: validateNewHomeAccess,
        component: () =>
          import('@/modules/home/containers/hse-performance.container.vue'),
      },
      {
        path: 'hse-performance',
        name: 'HSEPerformance',
        beforeEnter: validateNewHomeAccess,
        component: () =>
          import('@/modules/home/containers/hse-performance.container.vue'),
      },
      {
        path: 'risk-landscape',
        name: 'RiskLandscape',
        beforeEnter: validateNewHomeAccess,
        component: () =>
          import('@/modules/home/containers/risk-landscape.container.vue'),
      },
      {
        path: 'control-mapping',
        name: 'ControlMapping',
        beforeEnter: validateNewHomeAccess,
        component: () =>
          import('@/modules/home/containers/control-mapping.container.vue'),
      },
      {
        path: 'kpi-dashboard',
        name: 'HomeKpiDashboard',
        beforeEnter: validateLegacyHomeAccess,
        meta: {
          breadcrumb: {
            label: 'home.breadcrumbs.kpi-dashboard',
            route: 'HomeKpiDashboard',
          },
        },
        component: () =>
          import('@/modules/home/containers/dss-home.container.vue'),
      },
    ],
  },
]

export default index
